import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import ResponsiveShadow from './components/ResponsiveShadowLogin';

const styles = `
  @media (min-width: 768px) {
    .login-card-wrapper {
      margin-right: clamp(1rem, 6vw, 6rem);
    }
  }
`;

function LoginPage() {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(() => localStorage.getItem('rememberMe') === 'true');
  const [sessionMessage, setSessionMessage] = useState('');
  const navigate = useNavigate();

  React.useEffect(() => {
    const savedLogin = localStorage.getItem('rememberedLogin');
    if (savedLogin) {
      setLogin(savedLogin);
      setRememberMe(true);
    }
    const msg = sessionStorage.getItem('loginRedirectMessage');
    if (msg) {
      setSessionMessage(msg);
    }
  }, []);

  const handleEmailChange = event => setLogin(event.target.value);
  const handlePasswordChange = event => setSenha(event.target.value);

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    try {
      const response = await axios.post(
        API_BASE_URL.LOGIN,
        { login, senha }
      );
      const { token, user, userBind } = response.data;
      if (!token || !user || !userBind) {
        throw new Error('Dados de login inválidos');
      }

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('userBind', JSON.stringify(userBind));
      localStorage.setItem('login', user.login);
      localStorage.setItem('anoBase', new Date().getFullYear().toString());
      if (rememberMe) {
        localStorage.setItem('rememberedLogin', login);
        localStorage.setItem('rememberMe', 'true');
      } else {
        localStorage.removeItem('rememberedLogin');
        localStorage.removeItem('rememberMe');
      }
      sessionStorage.removeItem('loginRedirectMessage');
      navigate('/seleciona_entidade');
    } catch (error) {
      setErrorMessage('Login ou senha incorretos. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <style>{styles}</style>
      <div
      className="d-flex flex-column"
      style={{
        height: '100vh',
        width:'100vw',
        overflow:'hidden',
        backgroundImage: 'url(/assets/background_login.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="d-flex" style={{ flex: '1', minHeight: 0 }}>
        <div className="d-none d-md-flex align-items-center justify-content-center" style={{ flex: '2' }}>
          <img
            src="/assets/logo_ac_planeja.png"
            alt="Logo"
            className="img-fluid"
            style={{ maxHeight: '70%', objectFit: 'contain' }}
          />
        </div>
        <div className="d-flex align-items-center justify-content-center justify-content-md-end px-4" style={{ flex: '1', paddingLeft: '1rem' }}>
          <div className="w-100 login-card-wrapper" style={{ maxWidth: '380px' }}>
            <ResponsiveShadow
              style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              }}
            >
              <div className="p-4">
                <h3 className="text-center mb-0">Login</h3>
                <div style={{ height: '3px', background: 'linear-gradient(90deg, #007bff, #28a745)', margin: '0.5rem auto 1rem', width: '100%', borderRadius: '2px' }}></div>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="login" className="form-label">Usuário</label>
                    <div style={{ position: 'relative' }}>
                      <i className="bi bi-person-fill" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', zIndex: 1 }} />
                      <input type="text" className="form-control" id="login" value={login}
                        onChange={handleEmailChange} required
                        style={{ paddingLeft: '2.8rem' }} />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="senha" className="form-label">Senha</label>
                    <div style={{ position: 'relative' }}>
                      <i className="bi bi-lock-fill" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', zIndex: 1 }} />
                      <input type={showPassword ? 'text' : 'password'} className="form-control" id="senha"
                        value={senha} onChange={handlePasswordChange} required
                        style={{ paddingLeft: '2.8rem', paddingRight: '2.8rem' }} />
                      <button type="button" onClick={() => setShowPassword(!showPassword)} tabIndex={-1}
                        aria-label={showPassword ? 'Esconder senha' : 'Mostrar senha'}
                        style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#6c757d', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px', borderRadius: '4px', transition: 'color 0.2s' }}
                        onMouseEnter={e => { e.target.style.color = '#212529'; }}
                        onMouseLeave={e => { e.target.style.color = '#6c757d'; }}
                      >
                        {showPassword ? <i className="bi bi-eye-slash-fill" /> : <i className="bi bi-eye-fill" />}
                      </button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-1" style={{ fontSize: '0.875rem' }}>
                    <div className="form-check mb-0">
                      <input type="checkbox" className="form-check-input" id="rememberMe" checked={rememberMe}
                        onChange={e => setRememberMe(e.target.checked)} />
                      <label className="form-check-label" htmlFor="rememberMe">Lembrar acesso</label>
                    </div>
                    <button type="button" className="btn btn-link p-0"
                      onClick={() => navigate('/esqueci-senha')}
                      style={{ textDecoration: 'none', fontSize: 'inherit' }}>
                      Esqueci minha senha
                    </button>
                  </div>
                  {sessionMessage && (
                    <div className="alert alert-warning d-flex align-items-start gap-2" role="alert">
                      <i className="bi bi-exclamation-triangle-fill flex-shrink-0 mt-1"></i>
                      <span>{sessionMessage}</span>
                    </div>
                  )}
                  {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                  <button type="submit" className="btn btn-primary w-100 mt-2" disabled={isLoading}>
                    {isLoading ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Entrando...</> : 'Acessar'}
                  </button>
                  <p className="text-center text-muted mt-3 mb-0" style={{ fontSize: '0.75rem' }}>
                    <i className="bi bi-shield-lock-fill me-1"></i><strong>Segurança</strong><br />
                    Seus dados estão protegidos com criptografia e seguimos as melhores práticas de segurança.
                  </p>
                </form>
              </div>
            </ResponsiveShadow>
          </div>
        </div>
      </div>

      <footer style={{ borderTop: '1px solid rgba(255,255,255,0.4)', background: 'transparent', padding: '0.5rem 0', flexShrink: 0 }}>
        <div className="container text-white text-center" style={{ fontSize: '0.75rem' }}>
          <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
            <span><i className="bi bi-whatsapp me-1"></i><a href="https://wa.me/5581982621289" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">(81) 98262-1289</a></span>
            <span className="text-white-50">|</span>
            <span><i className="bi bi-envelope-fill me-1"></i><a href="mailto:suporte.sistemas@acpublica.com.br" className="text-white text-decoration-none">suporte.sistemasacpublica.com.br</a></span>
            <span className="text-white-50">|</span>
            <span><i className="bi bi-globe me-1"></i><a href="https://www.acpublica.com.br" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">www.acpublica.com.br</a></span>
          </div>
        </div>
      </footer>
      </div>
    </>
  );
}

export default LoginPage;